import React from 'react';
import propTypes from 'prop-types';
import style from './index.less';
import { transform } from '../../unit/const';
import { isMobile } from '../../unit';


export default class Guide extends React.Component {
  constructor() {
    super();
    this.state = {
      isMobile: isMobile() || window.innerWidth < 768,
    };
    this.handleResize = this.handleResize.bind(this);
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }
  handleResize() {
    const mobile = isMobile() || window.innerWidth < 768;
    if (mobile !== this.state.isMobile) {
      this.setState({ isMobile: mobile });
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.lan !== this.props.lan ||
      nextState.isMobile !== this.state.isMobile;
  }
  render() {
    if (this.state.isMobile) {
      return null;
    }
    return (
      <div>
        <div className={`${style.guide} ${style.right}`}>
          <div className={style.up}>
            <em style={{ [transform]: 'translate(0,-3px) scale(1,2)' }} />
          </div>
          <div className={style.left}>
            <em style={{ [transform]: 'translate(-7px,3px) rotate(-90deg) scale(1,2)' }} />
          </div>
          <div className={style.down}>
            <em style={{ [transform]: 'translate(0,9px) rotate(180deg) scale(1,2)' }} /></div>
          <div className={style.right}>
            <em style={{ [transform]: 'translate(7px,3px)rotate(90deg) scale(1,2)' }} />
          </div>
        </div>
        <div className={`${style.guide} ${style.left}`}>
          <div className={style.space}>SPACE</div>
        </div>
      </div>
    );
  }
}

Guide.propTypes = {
  lan: propTypes.string.isRequired,
};
